export const EVENT_ACTIONS = {
    ADD_EVENTS_DEFINITION: 'ADD_EVENTS_DEFINITION',
    CHANGE_SELECTED_EVENT: 'CHANGE_SELECTED_EVENT',
    ADD_EVENTS: 'ADD_EVENTS',
    UPDATE_EVENT: 'UPDATE_EVENT',
    ADD_EVENT: 'ADD_EVENT',
    CLEAR_EVENTS: 'CLEAR_EVENTS',
    CHANGE_TIMELINE_SELECTED_EVENT:'CHANGE_TIMELINE_SELECTED_EVENT',
    DISCARD_EVENT_TAB_DATA:'DISCARD_EVENT_TAB_DATA',
    ADD_VIEW_WIZARD:'ADD_VIEW_WIZARD',
    ADD_CURRENT_FINDING:'ADD_CURRENT_FINDING',
    ADD_REVIEW_EXTRACTION_KEY:'ADD_REVIEW_EXTRACTION_PAYLOAD'

};
